import { Brain, Smile, BarChart3 } from "lucide-react";
import { Reveal, SectionHeading } from "./shared";

const FEATURES = [
  {
    icon: Brain,
    title: "AI Workflow Automation",
    copy: "Automate repetitive administrative tasks so orthodontists can focus on patient care.",
    gradient: "from-[#2563EB] to-[#3B82F6]",
  },
  {
    icon: Smile,
    title: "Patient Engagement",
    copy: "Keep patients informed and motivated throughout treatment with AI-powered reminders and progress tracking.",
    gradient: "from-[#6366F1] to-[#8B5CF6]",
  },
  {
    icon: BarChart3,
    title: "Practice Intelligence",
    copy: "Gain actionable insights into clinic performance through intelligent analytics.",
    gradient: "from-[#0EA5E9] to-[#2563EB]",
  },
];

export default function WhyAlignexa() {
  return (
    <section id="about" data-testid="why-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <SectionHeading
          testId="why-heading"
          eyebrow="Why Alignexa AI"
          title="Built for the future of orthodontics"
          sub="One intelligent platform that quietly handles the busywork, so your practice runs on precision — not paperwork."
        />

        <div className="grid md:grid-cols-3 gap-6 mt-16">
          {FEATURES.map((feature, i) => (
            <Reveal key={feature.title} delay={i * 0.12}>
              <div
                data-testid={`why-card-${feature.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group relative h-full rounded-3xl border border-slate-200/80 bg-white p-8 transition-[box-shadow,transform,border-color] duration-500 hover:-translate-y-2 hover:shadow-[0_30px_60px_-15px_rgba(37,99,235,0.18)] hover:border-[#2563EB]/30"
              >
                <div className="absolute inset-x-8 top-0 h-px bg-gradient-to-r from-transparent via-[#2563EB]/40 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div
                  className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center shadow-[0_12px_28px_rgba(37,99,235,0.3)] transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3`}
                >
                  <feature.icon className="w-6 h-6 text-white" strokeWidth={1.8} />
                </div>
                <h3 className="font-display font-medium text-2xl tracking-tight text-[#0F172A] mt-7">
                  {feature.title}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed mt-3">{feature.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
